import { Injectable } from '@angular/core';
import { environment } from "@env/environment";
declare var SockJS;
declare var Stomp;
@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  
  constructor() {

  }
  public favStompClient;
  public oldRate :  any[] = [];
  public newFavRate :  any[] = [];

  initializeFavRateWebSocketConnection() {

    const user=JSON.parse(localStorage.getItem('user'))
    const userid=user.parentUserId!=0?user.parentUserId:user.userId;
    const serverUrl = `${environment.api.baseurl}/socketReg`;
    console.log(serverUrl);
    const ws = new SockJS(serverUrl);
    this.favStompClient = Stomp.over(ws);
    const that = this;
    // tslint:disable-next-line:only-arrow-functions
    this.favStompClient.connect({}, function(frame) {
      that.favStompClient.subscribe(`/topic/favRate/${userid}`, (message) => {
        if (message.body) {
          that.newFavRate=JSON.parse(message.body);
         
        }
      },{ id: 'FAVRATE_'+userid });
    });
  }

  initializeFavRateWebSocket() {
    const serverUrl = `${environment.api.baseurl}/socketReg`;
    console.log(serverUrl);
    const ws = new SockJS(serverUrl);
    this.favStompClient = Stomp.over(ws);

  }

  CloseAllWebsocketClient() {

    


    if(this.favStompClient){
      this.CloseFavRateConnection();
    
    }
    if(this.allStompClient){

    this.allStompClient.disconnect();
    this.allStompClient=null;
    }
    console.info("All Web socket Clossed")
  }

  CloseFavRateConnection() {

    const user=JSON.parse(localStorage.getItem('user'));
    console.log("user:"+user);
    var userid=0;
    if(user)
      userid=user.parentUserId!=0?user.parentUserId:user.userId;
    console.log('FavRate close');
    if(this.favStompClient ){
    this.favStompClient.unsubscribe('FAVRATE_'+userid);
    this.favStompClient.disconnect();
    this.favStompClient=null;
    }
  }



  
  public allStompClient;
  public alloldRate :  any[] = [];
  public newAllRate :  any[] = [];

  initializeAllRateWebSocketConnection() {

    const user=JSON.parse(localStorage.getItem('user'))
    const serverUrl = `${environment.api.baseurl}/socketReg`;
    console.log(serverUrl);
    const ws = new SockJS(serverUrl);
    this.allStompClient = Stomp.over(ws);
    const that = this;
    // tslint:disable-next-line:only-arrow-functions
    this.allStompClient.connect({}, function(frame) {
      that.allStompClient.subscribe(`/topic/rateAll/${user.userId}`, (message) => {
        if (message.body) {
          that.newAllRate=JSON.parse(message.body);
         
        }
      },{ id: 'ALLRATE_'+user.userId });
    });
  }

  CloseAllRateConnection() {
    const user=JSON.parse(localStorage.getItem('user'));
    console.log('All Rate close');
    if(this.allStompClient){
    this.allStompClient.unsubscribe('ALLRATE_'+user.userId);
    this.allStompClient.disconnect();
    this.allStompClient=null;
    }
  }




  sendMessage(message) {

var    json={"msg":message};
console.log("Send Obj:"+json.msg)
this.favStompClient.send('/sdSocket/chat/1' , {}, JSON.stringify({msg: message}));
  }


  
  public spotRate : any
  initializeSpotRateWebSocketConnection(curPair) {
    const that = this;
    console.log('All SPOT Rate ssss');
    // tslint:disable-next-line:only-arrow-functions

      that.favStompClient.subscribe(`/topic/spotRate/${curPair}`, (message) => {
        if (message.body) {
         this.spotRate=JSON.parse(message.body);
         
        }
      },{ id: 'SPOTRATE_'+curPair });
  
  }

  CloseSpotRateConnection(curPair) {

    console.log('All SPOT Rate close');
    if(this.favStompClient){
    this.favStompClient.unsubscribe('SPOTRATE_'+curPair);
    }
  }

  



}
